<template>
  <div class="top-bar">
    <div class="title" :style="{'color':color}">{{ title }}</div>
    <div class="absoluteImg" @click="$router.go(-1)">
      <img style="width:.52rem" :src="white ? fanhuiWhite : fanhui" alt="">
    </div>
  </div>
</template>

<script>
  import fanhui from '@/assets/img/返回.png'
  import fanhuiWhite from '@/assets/img/返回white.png'
  
  export default {
    name: 'footerBar',
    components: {
    },
    data () {
      return {
        fanhui: fanhui,
        fanhuiWhite:fanhuiWhite
      }
    },
    props:[
      'title',
      'color',
      'white'
    ],
    methods: {
      onChange(index) {

      },
    },
    mounted () {
    },
  }
</script>

<style lang="stylus" scoped>
  /deep/.top-bar{
    width: 100%;
    height: 50px;
    display: flex;
    align-items center;
    justify-content center;
    position relative;
    .title{
      font-size 18px;
    }
    .absoluteImg{
      position absolute;
      left: 20px;
      cursor pointer
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/top-bar/index.vue